import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// Redux
import { forgetPasswordForUser,setApplicationNumber } from '../../../actions/loginActions';
import CustomButton from '../../../components/CustomButton';
import CustomTextField from '../../../components/CustomTextField';
// Images
import ApplicationIcon from '../../../assets/application.svg';
import UserIcon from '../../../assets/user.svg';
import PopUpModal from '../../../components/PopUpModal';
import { makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import { Alert, AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  dialogCustomizedWidth: {
    [theme.breakpoints.up('sm')]: {
      'max-width': '30%',
    },
  },
}));

const ForgotPassword = () => {

  const defaultInputs = {
    userName: {
      type: 'generic',
      value: '',
      errorLabel: '',
      error: false,
    },
    uid: {
      type: 'generic',
      value: '',
      errorLabel: '',
      error: false,
    },
  };

  const classes = useStyles();
  const childRef = useRef();
  //States
  const [inputs, setInputs] = useState(defaultInputs);
  const [loginType] = useState('student');
  // const [showSwipe, setShowSwipe] = useState(false);
  const [isDisabled, setDisabled] = useState(true);

  // Redux Props
  const dispatch = useDispatch();

  const message = useSelector((state) =>
    get(state, 'loginReducer.isSwipe.message', '')
  );
  const isError = useSelector((state) =>
    get(state, 'loginReducer.isSwipe.error', '')
  );
  const isLoginLoading = useSelector(state =>
    get(state, 'loadingReducer.isLoginLoading', false)
  );
  const appNumber = useSelector(state => get(state, 'loginReducer.applicationNumber', ''));
  useEffect(() => {
    handleDisable();
  }, [inputs.userName.value, inputs.uid.value,appNumber.uid]);

  const onChangeTextInput = (id, value) => {
    
    setInputs((prevInput) => ({
      ...prevInput,
      [id]: { ...prevInput[id], value: value },
    }));
    if (id == 'uid') {
      dispatch(
        setApplicationNumber({
          uid: value
        })
      )
    }
  };

  const handleKeypress = e => {
    //it triggers by pressing the enter key
    let code = e.keyCode || e.which;
    if (code === 13) {
      onCreatePass();
    }
  };

  const onCreatePass = () => {
    let isUId = validateForm('uid', inputs.uid.value);
    let isUid2 = validateForm('uid', appNumber.uid);
    
    let isUser = validateGeneric('userName', inputs.userName.value.trim());
    if (loginType == 'student' && (isUId || isUid2) && isUser) {
      forgetPasswordForUser(
        inputs.uid.value ? inputs.uid.value :appNumber.uid,
        inputs.userName.value.trim(),
        dispatch
      ).then(() => {
        childRef.current.handleClickOpen();
      });
    } else if (isUId && isUser && inputs.userName.value.trim().length > 3) {
      forgetPasswordForUser(
        inputs.uid.value ? inputs.uid.value :appNumber.uid,
        inputs.userName.value.trim(),
        dispatch
      ).then(() => {
        childRef.current.handleClickOpen();
      });
    }
  };

  const validateGeneric = (id, val) => {
    if (!val) {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
        },
      }));
      return false;
    } else {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
        },
      }));
      return true;
    }
  };

  const validateForm = (id, val) => {
    if (!(inputs.uid.value||appNumber.uid) || !val) {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
        },
      }));
      return false;
    } else if (!/^\d{8}$/.test(inputs.uid.value?inputs.uid.value:appNumber.uid)) {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: 'Please enter valid Application Form Number',
          error: true,
        },
      }));
      return false;
    } else {
      setInputs((prevInput) => ({
        ...prevInput,
        [id]: {
          ...prevInput[id],
          errorLabel: '',
          error: false,
        },
      }));
      return true;
    }
  };

  // const validateEmail = (id, val) => {
  //   var reg = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
  //   if (!val) {
  //     setInputs((prevInput) => ({
  //       ...prevInput,
  //       [id]: {
  //         ...prevInput[id],
  //         errorLabel: '',
  //       },
  //     }));
  //     return false;
  //   } else if (!reg.test(val)) {
  //     setInputs((prevInput) => ({
  //       ...prevInput,
  //       [id]: {
  //         ...prevInput[id],
  //         errorLabel: 'Invalid Email Address',
  //       },
  //     }));
  //     return false;
  //   } else {
  //     setInputs((prevInput) => ({
  //       ...prevInput,
  //       [id]: {
  //         ...prevInput[id],
  //         errorLabel: '',
  //       },
  //     }));
  //     return true;
  //   }
  // };

  const handleDisable = () => {
    let isUId = validateForm('uid', inputs.uid.value);
    let isUid2 = validateForm('uid', appNumber.uid);

    if (
      (inputs.uid.value || appNumber.uid )&&
      inputs.userName.value.trim() &&
      (isUId || isUid2) &&
      inputs.userName.value.trim().length > 2
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const header = isError ? (
    <div>Opps! Error in recovering password </div>
  ) : (
      <div>Hurray! Password recovered sucessfully</div>
    );
  const body = isError ? (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {message}
    </Alert>
  ) : (
      <React.Fragment>
        <Alert severity="success">
          <AlertTitle>Success</AlertTitle>
          {message}
        </Alert>
        <div className="seprator" />

        <p className="flex flex-center">
          <Link to="/login" className="secondary-link">
            Back to Login
        </Link>
        </p>
      </React.Fragment>
    );

  return (
    <div className="form-wrapper">
      <div className="greeting">
        <h1 className="welcome">Recover Password</h1>
        <p className="info">Use the form below to recover password</p>
      </div>

      <div className="input-container">
        <CustomTextField
          id="application-form-number"
          label="Application Form Number"
          color="secondary"
          className="width-100"
          onChange={e => onChangeTextInput('uid', e.target.value)}
          icon={ApplicationIcon}
          error={inputs.uid.error}
          helperText={inputs.uid.errorLabel}
          onKeyPress={handleKeypress}
          defaultValue={appNumber.uid}
        />
      </div>
      <div className="input-container">
        <CustomTextField
          id="full-name"
          label="Full Name"
          color="secondary"
          className="width-100"
          value={inputs.userName.value}
          onChange={(e) => onChangeTextInput('userName', e.target.value)}
          icon={UserIcon}
          error={inputs.userName.error}
          onKeyPress={handleKeypress}
        />
      </div>
      <div className="mb-10">
        <CustomButton
          name="Recover password"
          handler={() => onCreatePass()}
          disabled={isDisabled || isLoginLoading}
          progressShow={isLoginLoading}
          className={isLoginLoading ? 'loading-btn' : ''}
        />
      </div>
      <div className="seprator">
        <span>or</span>
      </div>

      <p className="flex flex-center">
        <Link to="/login" className="secondary-link">
        Back to Login
        </Link>
      </p>
      <PopUpModal
        ref={childRef}
        header={header}
        body={body}
        width={classes.dialogCustomizedWidth}
      />
    </div>
  );
};
ForgotPassword.propTypes = {
  location: PropTypes.object,
};

export default ForgotPassword;
